import { isBefore, parseISO, sub } from "date-fns";

import { ChildParentConnectionI } from "@seneca/class-service-types";
import { MIN_DAYS_TO_NOTIFY } from "@seneca/parents-service-consts";

export function canSendParentInvite({
  timeLastInviteSent,
  status
}: ChildParentConnectionI) {
  if (status !== "pending") {
    return false;
  }

  if (!timeLastInviteSent) {
    return true;
  }

  const dateLastInviteSent = parseISO(timeLastInviteSent);
  const minDate = sub(new Date(), {
    days: MIN_DAYS_TO_NOTIFY
  });

  return isBefore(dateLastInviteSent, minDate);
}
